import React from 'react'
import {
  Dialog,
  Typography,
  Button
} from '@material-ui/core'
import { useStyles } from './style'

const AddTeamMemberMaximumDialog = ({
  open,
  handleOk
}) => {
  const classes = useStyles()

  return (
    <Dialog open={open}>
      <div className={classes.root}>
        <Typography className={classes.text}>You have reached the maximum of 20 members.</Typography>
        <Typography className={classes.text}>To add new members, please remove existing ones from the team.</Typography>
        <div className={classes.buttons}>
          <Button className={classes.rightButton} variant='contained' color='secondary' onClick={handleOk}>Ok</Button>
        </div>
      </div>
    </Dialog>
  )
}

export default AddTeamMemberMaximumDialog
